// extracted by css-extract-rspack-plugin
export default {"resizeSurface":"KOR4a_FekLAUBq7X","dialogChartViewport":"rVmSoaPSPc4sHx4I","resizeSnapshot":"VrprvdnfcMM8ExFI"};